import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const activityGridColumns = () => [
    {
        field: 'activity',
        headerName: 'Activity',
    },
    {
        field: 'activity_type',
        headerName: 'Activity Type',
        hide: true,
    },
    {
        field: 'activity_id',
        headerName: 'Activity ID',
        hide: true
    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        width: 120,
        filter: 'agNumberColumnFilter',
        sort: 'desc',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'age',
        headerName: 'Age (Days)',
        width: 80,
        hide: true,
    },

    {
        field: 'perc_total',
        headerName: '% ' + apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'total_duration',
        headerName: 'Total Duration',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        width: 120,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
 
];
